import "../../css/services.css";
import { useDispatch } from "react-redux";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import logo from "../../geuzenetlog.png";
import { getAllServices } from "../../store/actions/services";
import { selectServicesList } from "../../store/selectors/services";
import NewTable from "../../components/newTable/newTable";

import {
  setCategories,
  getAppUser,
  reduxInit,
} from "../../store/actions/navigation";
import {
  selectNavigation,
  selectAppUser,
} from "../../store/selectors/navigation";

const validUser = (user) =>
  user
    ? !(!user.userRoles.includes("user") && !user.userRoles.includes("admin"))
    : false;
function Services() {
  useEffect(() => {
    dispatch(reduxInit()); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const appUser = useSelector(selectAppUser);
  const headerRef = useRef();
  const dispatch = useDispatch();
  const navigation = useSelector(selectNavigation);
  const services = useSelector(selectServicesList);
  useEffect(() => {
    const setMenu = () => {
      if (!validUser(appUser)) {
        dispatch(setCategories("", "", ""));
      } else {
        dispatch(setCategories("Services", "Overview", "list"));
      }
    };

    setMenu();
  }, [dispatch, appUser]);
  useEffect(() => {
    dispatch(getAppUser());
    const getItems = () => {
      if (services.length === 0 && validUser(appUser)) {
        dispatch(getAllServices());
      }
    };
    getItems(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, services, navigation.menuSub, navigation.menuMain]);
  if (!validUser(appUser)) {
    return <></>;
  } else {
    console.log(services);
    return (
      <div className={services.length === 0 ? "Services loading" : "Services"}>
        <>
          <div className="topBar"></div>
          <div className="bigTableWrapper" ref={headerRef}>
            {services.length > 0 ? (
              <NewTable
                wrapperRef={headerRef}
                tit={"servicesOverview"}
                tabletype={"big"}
                data={services.filter(
                  (service) =>
                    service.contractId &&
                    service.customerName &&
                    service.serviceDescription
                )}
                width={headerRef.current ? headerRef.current.clientWidth : 100}
              />
            ) : (
              <img className="landingLogo" src={logo} alt="company logo" />
            )}
          </div>
        </>
      </div>
    );
  }
}

export default Services;
